/**
 * Image Helpers
 * =============
 * Every JPEG/JPG referenced through toWebP() has a pre-generated .webp
 * sibling committed alongside it in public/images (same name, same
 * directory). Used to render <picture> with a WebP source ahead of the
 * original file as fallback, without touching the original at all.
 */

export const toWebP = (src) => src.replace(/\.(jpe?g|png)$/i, '.webp');
